import React, { ReactNode } from "react"
import { Helmet } from 'react-helmet'
import Cookies from 'js-cookie'
import HeaderNav from "./header-nav"
import FooterNav from "./footer-nav"
import Popup from "./popup"

export default function Layout({children, title,}: {children: ReactNode; title: string;}) {
    const [isIntroDismissed, setIsHidden] = React.useState(true)

    React.useEffect(() => { 
        // important to hide by default, because gatsby mixes up the layout 
        // when it grabs the cookie at render time
        if (!Cookies.get('hidden')) {
            setIsHidden(false)
        }
    }, [])
    
    return (
        <main style={{maxWidth: '100%', display: 'flex', flexDirection: 'column', height: '100%',}}>
            <Helmet>
                <title>{title} | NL Public Art Online</title>
            </Helmet>

            <HeaderNav />
            <div style={{flex: 1}}>
                {!isIntroDismissed && <Popup setIsHidden={() => {
                    Cookies.set('hidden', true)
                    setIsHidden(true)
                }} />}
                {children}
            </div>
            <FooterNav />
        </main>
    )
}